export default __webpack_public_path__ + "static/media/waves_video.b20e535e.mp4";